var map = {
	"../bookmark/bookmark.module": [
		"./src/app/bookmark/bookmark.module.ts",
		"bookmark-bookmark-module"
	],
	"../discover/discover.module": [
		"./src/app/discover/discover.module.ts",
		"discover-discover-module"
	],
	"../recipes/recipes.module": [
		"./src/app/recipes/recipes.module.ts",
		"recipes-recipes-module"
	],
	"./create/create.module": [
		"./src/app/create/create.module.ts",
		"create-create-module"
	],
	"./recipe-detail-page/recipe-detail-page.module": [
		"./src/app/recipe-detail-page/recipe-detail-page.module.ts",
		"recipe-detail-page-recipe-detail-page-module"
	],
	"./tabs/tabs.module": [
		"./src/app/tabs/tabs.module.ts",
		"tabs-tabs-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;